var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Página no encontrada")]),_c('p',[_vm._v("Lo sentimos, la página que está buscando no existe.")])])
}]

export { render, staticRenderFns }